export default "__VITE_ASSET__5be8b851__"